import { useListUsersGoals } from '@akin-home/goals/frontend';
import { useCurrentUser } from '../../users';

/** Wrapper hook for fetching your own goals */
export const useMyGoals = () => {
  const { id, username } = useCurrentUser();

  return useListUsersGoals({
    user_id: id,
    username,
  });
};
